function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import CollapsibleAdvanced, { CollapsibleContext } from './CollapsibleAdvanced';
import CollapsibleBody from './CollapsibleBody';
import CollapsibleTrigger from './CollapsibleTrigger';
import CollapsibleVisible from './CollapsibleVisible';
var styleIcons = {
  basic: {
    iconWhenClosed: React.createElement(FontAwesomeIcon, {
      icon: faPlusCircle
    }),
    iconWhenOpen: React.createElement(FontAwesomeIcon, {
      icon: faMinusCircle
    })
  } // card and card-lg use the defaults specified in defaultProps

};
var Collapsible = React.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      title = props.title,
      styling = props.styling,
      iconWhenClosed = props.iconWhenClosed,
      iconWhenOpen = props.iconWhenOpen,
      other = _objectWithoutProperties(props, ["children", "className", "title", "styling", "iconWhenClosed", "iconWhenOpen"]);

  var icons = Object.assign({
    iconWhenClosed: iconWhenClosed,
    iconWhenOpen: iconWhenOpen
  }, styleIcons[styling]);
  var titleElement = React.isValidElement(title) ? title : React.createElement("span", null, title);
  return React.createElement(Collapsible.Advanced, _extends({}, other, {
    className: classNames(className, "collapsible-".concat(styling)),
    ref: ref
  }), React.createElement(Collapsible.Trigger, {
    className: "collapsible-trigger"
  }, titleElement, React.createElement("span", {
    className: "ml-2"
  }, React.createElement(Collapsible.Visible, {
    whenClosed: true
  }, icons.iconWhenClosed), React.createElement(Collapsible.Visible, {
    whenOpen: true
  }, icons.iconWhenOpen))), React.createElement(Collapsible.Body, {
    className: "collapsible-body"
  }, children));
});
Collapsible.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.node.isRequired,
  styling: PropTypes.oneOf(['basic', 'card', 'card-lg']),
  iconWhenClosed: PropTypes.element,
  iconWhenOpen: PropTypes.element
};
Collapsible.defaultProps = {
  className: undefined,
  styling: 'card',
  iconWhenClosed: React.createElement(FontAwesomeIcon, {
    icon: faPlus
  }),
  iconWhenOpen: React.createElement(FontAwesomeIcon, {
    icon: faMinus
  })
};
Collapsible.Advanced = CollapsibleAdvanced;
Collapsible.Body = CollapsibleBody;
Collapsible.Trigger = CollapsibleTrigger;
Collapsible.Visible = CollapsibleVisible;
Collapsible.Context = CollapsibleContext;
export default Collapsible;
//# sourceMappingURL=index.js.map